export default [
  {
    name: 'checkin-dashboard',
    path: '/checkin-dashboard',
    component: () => import(/* webpackChunkName: "checkin-dashboard" */ './Index.vue'),
    meta: {
      showNavbar: true,
      title: 'Dashboard check-in',
      icon: 'bxs-dashboard',
      label: 'Dashboard check-in',
      roles: ['Admin']
    }
  }
]
